import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(VAutocomplete, {
    staticClass: "mx-2",
    attrs: {
      "item-text": _vm.getUnidadeSiglaAndNome,
      items: _vm.unidades,
      disabled: _vm.disabled,
      "item-value": "id",
      label: "Unidade",
      "prepend-icon": "account_balance",
      placeholder: "Digite para pesquisar...",
      "return-object": "",
    },
    model: {
      value: _vm.value.selecionado,
      callback: function ($$v) {
        _vm.$set(_vm.value, "selecionado", $$v)
      },
      expression: "value.selecionado",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }